import { Container, Row, Col } from "react-bootstrap";
import styles from "./VirtualServersPage.module.css";
import { LowerMainBannerHeader, UpperMainBannerHeader } from "./DataCenterSvg";
import { useState, useEffect, useRef } from "react";
import { useLang } from "../LangContext";
import { useTheme } from "../ThemeContext";
import MinorHeader from "./MinorHeader";
import { motion } from "framer-motion";

function MainBanner({ isLg, isXl }) {
  const { s, toggleTheme } = useTheme();
  const { lang, changeLang, t } = useLang();

  return (
    <div className={styles.mainBannerContainer} style={s.VSMainBanner}>
      <Row>
        <Col xs={12} md={7}>
          <div className={`${styles.mainBannerTextBlock} h-100`}>
            <h4 style={{ color: s.DCProsHeader, letterSpacing: "1.5px" }}>
              {t("DSMainBannerHeader")}
            </h4>
            <p style={{ color: s.DCProsText }}>
              {t("DSMainBannerText1")}
              {(isLg || isXl) && <br />}
              {t("DSMainBannerText2")}
              {(isLg || isXl) && <br />} {t("DSMainBannerText3")}
            </p>
          </div>
        </Col>
        <Col xs={12} md={5}>
          <div className="d-flex h-100 justify-content-center align-items-center">
            <svg
              width="269"
              height="162"
              viewBox="0 0 269 162"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              {s.DSMainBannerIcon}

              {/* Анимированный курсор */}
              <motion.g
                animate={{
                  x: [0, -37, -35, 12, 10, 2, 0], // x-координаты: начало, влево, вправо, назад
                  y: [0, -17, -15, -32, -30, 2, 0],
                }}
                transition={{
                  duration: 3.7,
                  ease: "easeInOut",
                  repeat: Infinity,
                  repeatType: "loop",
                  times: [0.35, 0.05, 0.35, 0.05, 0.35, 0.05],
                }}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M227.852 115.115C226.261 116.157 225.963 118.874 226.004 120.528C226.004 120.549 226.004 120.569 226.005 120.59L226.273 140.684C226.323 144.409 232.098 146.211 234.229 143.166L238.303 137.345C239.058 136.266 240.481 135.689 242.021 135.837L250.708 136.67C251.282 136.725 251.808 136.69 252.278 136.582C252.397 136.566 252.533 136.536 252.688 136.492C255.715 135.634 255.752 131.951 255.503 130.117C255.181 130.586 254.818 131.085 254.448 131.591C254.101 131.034 253.577 130.516 252.858 130.092L232.391 118.001C231.324 117.37 230.156 117.178 229.114 117.333C228.961 115.764 228.602 114.624 227.852 115.115Z"
                  fill="#23C1FF"
                />
                <path
                  d="M227.53 117.703C227.501 115.518 230.263 114.399 232.468 115.702L252.935 127.792C255.841 129.509 254.635 133.201 251.273 132.878L242.586 132.044C240.696 131.863 238.95 132.571 238.024 133.894L233.95 139.716C232.303 142.07 227.838 140.677 227.8 137.798L227.53 117.703Z"
                  fill="#E5EEF7"
                  stroke="#23C1FF"
                  strokeWidth="1.8"
                />
              </motion.g>
            </svg>
          </div>
        </Col>
      </Row>
    </div>
  );
}

function CountryCard({
  header,
  price,
  cpu,
  vcpu,
  ram,
  size,
  ddos,
  gpu,
  hint,
  setHint,
  index,
}) {
  const { s, toggleTheme } = useTheme();
  const { lang, changeLang, t } = useLang();

  const params = [
    {
      key: "CPU",
      val: cpu,
    },
    {
      key: t("vcpu"),
      val: vcpu,
    },
    {
      key: t("ram"),
      val: ram,
    },
    {
      key: t("size"),
      val: size,
    },
    {
      key: t("ddos"),
      val: ddos,
    },
    {
      key: t("gpu"),
      val: gpu,
    },
  ];
  return (
    <div
      className={styles.countryCard}
      style={{ ...s.DCProsCard, height: "auto" }}
    >
      <div
        className={styles.countryHeaderContainer}
        style={s.VSCountryCardHeaderContainer}
      >
        <div
          className={styles.countryBlackEl}
          style={{ backgroundColor: s.DCProsHeader }}
        >
          <h4 style={{ fontSize: "17px", margin: "0", color: s.guideCard2Bg }}>
            {header}
          </h4>
        </div>
        <p style={{ color: s.DCProsHeader }}>{price}</p>
      </div>
      <div
        // className={styles.countryParams}
        className="mt-3"
      >
        {params.map(
          (el) =>
            el.val && (
              <div className={styles.countryParamsRow} key={el.key}>
                <p
                  className={styles.countryParamsHeader}
                  style={{ color: s.VSCountryCardVal }}
                >
                  {el.key}
                </p>
                <hr style={{ backgroundColor: s.VSHrBg }} />
                {el.key.length + el.val.length <= 35 ? (
                  <p
                    className={styles.countryParamsText}
                    style={{ color: s.cardBlinkColor }}
                  >
                    {el.val}
                  </p>
                ) : (
                  <div style={{ position: "relative" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      style={{ marginBottom: "1px" }}
                      onMouseEnter={() => setHint([index, el.key])}
                      onMouseLeave={() => setHint([])}
                    >
                      <path
                        d="M9.0013 17.3337C4.39893 17.3337 0.667969 13.6027 0.667969 9.00033C0.667969 4.39795 4.39893 0.666992 9.0013 0.666992C13.6036 0.666992 17.3346 4.39795 17.3346 9.00033C17.3346 13.6027 13.6036 17.3337 9.0013 17.3337ZM9.0013 15.667C12.6832 15.667 15.668 12.6822 15.668 9.00033C15.668 5.31843 12.6832 2.33366 9.0013 2.33366C5.3194 2.33366 2.33464 5.31843 2.33464 9.00033C2.33464 12.6822 5.3194 15.667 9.0013 15.667ZM8.16797 4.83366H9.83463V6.50033H8.16797V4.83366ZM8.16797 8.16699H9.83463V13.167H8.16797V8.16699Z"
                        fill="#A8A8A8"
                      />
                    </svg>
                    {hint && hint[0] === index && hint[1] === el.key && (
                      <div
                        style={{
                          position: "absolute",
                          top: "calc(100% + 5px)", // Позиция ниже иконки
                          left: "50%",
                          transform: "translateX(-50%)", // Центрируем по горизонтали
                          borderRadius: "4px",
                          border: "1px solid #222525",
                          padding: "0 7px",
                          background: "#FFF",
                          color: "black", // Белый текст
                          borderRadius: "4px", // Скругленные углы
                          height: "26px",
                          fontSize: "14px", // Размер текста
                          fontFamily: "Gilroy-medium", // Шрифт, как в вашем проекте
                          whiteSpace: "nowrap", // Текст в одну строку
                          zIndex: 100, // Поверх остальных элементов
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {el.val} {/* Текст tooltip из данных */}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )
        )}
      </div>
      <a href="https://my.qwins.co" style={{ textDecoration: "none" }}>
        <button
          // className={`${styles.countryBuyBtn} mt-4`}
          // className={`mt-1 ${styles.minorBtn}`}
          className={`${styles.countryBuyBtn} mt-4`}
          style={{
            color: s.guideCard2Bg,
            ...s.VSMainBannerBtnHover,
          }}
        >
          {t("VSBuyBtnText")}
        </button>
      </a>
    </div>
  );
}

function CountryCards({ curCountry }) {
  const { lang, changeLang, t } = useLang();
  const [hint, setHint] = useState([]);

  const cards = {
    ger: [...t("DPGer")],
    net: [...t("DPNet")],
    rus: [...t("DPRus")],
  };
  return (
    <motion.div
      className="mt-5"
      key={curCountry}
      initial={{ opacity: 0 }} // Начальное состояние
      animate={{ opacity: 1 }} // Конечное состояние
      transition={{ duration: 0.5 }}
    >
      <Row xs={1} md={2} xxl={4} className="gy-4">
        {cards[curCountry].map((el, index) => {
          return (
            <Col>
              <CountryCard
                {...el}
                index={index}
                key={index}
                hint={hint}
                setHint={setHint}
              />
            </Col>
          );
        })}
      </Row>
    </motion.div>
  );
}

function Pros2Card({ header, description, picSrc, children }) {
  const { s, toggleTheme } = useTheme();

  const descriptionClass = `${styles.cardDescr}`;
  const headerClass = `${styles.cardHeader} m-0`;
  const divClass = `${styles.card} h-100 ${styles.pros2CardStructure}`;
  return (
    <Col>
      <div
        className={divClass}
        style={s.cardBg}
        //   style={{ paddingBottom: "7px" }}
      >
        <Row>
          <Col xs={12}>
            <div className="d-flex align-items-center gap-3">
              <div>
                <div className="panel-container" style={s.card2IconBG}>
                  {children}
                </div>
              </div>
              {/* <img src={picSrc} alt="IMG" className={styles.prosSmallGif} /> */}
              <h4
                className={headerClass}
                style={{ fontSize: "22px", ...s.cardHeader }}
              >
                {header}
              </h4>
            </div>
          </Col>
          <Col xs={12}>
            <p
              className={descriptionClass}
              style={{ marginTop: "28px", ...s.card2Descr }}
              // style={{ maxWidth: "82%" }}
            >
              {description}
            </p>
          </Col>
        </Row>
      </div>
    </Col>
  );
}

function ProsModule2({ isXl }) {
  const { s, toggleTheme } = useTheme();
  const { lang, changeLang, t } = useLang();
  const prosCards = [
    {
      header: t("VSProsHeader2"),
      text: t("VSProsText2"),
      pic: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M1.01483 14.9992C0.56636 14.2506 0.229748 13.4694 0 12.6734C1.00896 12.1773 1.69986 11.1664 1.69986 9.99999C1.69986 8.83448 1.00999 7.82415 0.00228242 7.32765C0.465763 5.71702 1.34591 4.21703 2.59733 2.99097C3.54766 3.58502 4.80166 3.65619 5.84993 3.07295C6.89821 2.48971 7.46125 1.40758 7.40256 0.31745C9.13013 -0.113918 10.9182 -0.0984802 12.5973 0.32003C12.5396 1.40929 13.1026 2.49017 14.1501 3.07295C15.1984 3.65617 16.4523 3.58502 17.4026 2.99103C18.003 3.58072 18.5367 4.25226 18.9852 5.00084C19.4336 5.7494 19.7703 6.53062 20 7.32652C18.991 7.82262 18.3001 8.83358 18.3001 9.99999C18.3001 11.1656 18.99 12.1758 19.9977 12.6723C19.5343 14.283 18.6541 15.7829 17.4027 17.009C16.4523 16.415 15.1984 16.3438 14.1501 16.927C13.1017 17.5102 12.5388 18.5924 12.5974 19.6826C10.8699 20.1139 9.08189 20.0985 7.40269 19.68C7.46036 18.5907 6.89738 17.5098 5.84993 16.927C4.80169 16.3438 3.54775 16.4149 2.59744 17.0089C1.99706 16.4192 1.46331 15.7477 1.01483 14.9992ZM6.88745 15.1953C8.01978 15.8253 8.83298 16.8213 9.22247 17.9644C9.73946 18.0117 10.2599 18.0124 10.777 17.966C11.1663 16.8223 11.9797 15.8256 13.1125 15.1953C14.2454 14.5649 15.5479 14.3846 16.7703 14.6314C17.0706 14.2231 17.3302 13.7884 17.5461 13.3332C16.7137 12.4367 16.2251 11.26 16.2251 9.99999C16.2251 8.74 16.7137 7.5634 17.5461 6.66685C17.4381 6.44089 17.3187 6.21864 17.1881 6.00067C17.0575 5.78268 16.9174 5.57201 16.7683 5.36898C15.5466 5.61528 14.2449 5.43469 13.1125 4.80471C11.9802 4.17471 11.1671 3.17861 10.7775 2.03567C10.2606 1.98827 9.74009 1.98759 9.22309 2.03404C8.83371 3.17764 8.0203 4.1744 6.88745 4.80471C5.75456 5.43502 4.45212 5.61546 3.22974 5.36859C2.92945 5.77691 2.66985 6.21159 2.45397 6.66672C3.28632 7.56331 3.7749 8.74 3.7749 9.99999C3.7749 11.26 3.28634 12.4366 2.45397 13.3331C2.56199 13.5591 2.68127 13.7814 2.81187 13.9993C2.94246 14.2173 3.08254 14.4279 3.23165 14.631C4.45349 14.3848 5.75517 14.5653 6.88745 15.1953ZM9.99998 12.9995C8.28102 12.9995 6.88745 11.6566 6.88745 9.99999C6.88745 8.34347 8.28102 7.0005 9.99998 7.0005C11.719 7.0005 13.1125 8.34347 13.1125 9.99999C13.1125 11.6566 11.719 12.9995 9.99998 12.9995ZM9.99998 10.9998C10.573 10.9998 11.0375 10.5522 11.0375 9.99999C11.0375 9.44778 10.573 9.00016 9.99998 9.00016C9.42696 9.00016 8.96247 9.44778 8.96247 9.99999C8.96247 10.5522 9.42696 10.9998 9.99998 10.9998Z"
            fill={s.cardBlinkColor}
          />
        </svg>
      ),
    },
    {
      header: t("VSProsHeader3"),
      text: t("VSProsText3"),
      pic: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="20"
          viewBox="0 0 17 20"
          fill="none"
        >
          <path
            d="M7.39243 12.093V13.9535C4.33038 13.9535 1.84811 16.4524 1.84811 19.5349H0C0 15.4248 3.3097 12.093 7.39243 12.093ZM7.39243 11.1628C4.32919 11.1628 1.84811 8.66512 1.84811 5.5814C1.84811 2.49767 4.32919 0 7.39243 0C10.4557 0 12.9368 2.49767 12.9368 5.5814C12.9368 8.66512 10.4557 11.1628 7.39243 11.1628ZM7.39243 9.30233C9.43459 9.30233 11.0886 7.63721 11.0886 5.5814C11.0886 3.52558 9.43459 1.86047 7.39243 1.86047C5.35027 1.86047 3.69621 3.52558 3.69621 5.5814C3.69621 7.63721 5.35027 9.30233 7.39243 9.30233ZM9.78998 16.5688C9.73278 16.3266 9.70256 16.0739 9.70256 15.814C9.70256 15.5541 9.73278 15.3014 9.78989 15.0592L8.87359 14.5266L9.79765 12.9153L10.7146 13.4483C11.0778 13.1024 11.5207 12.8404 12.0127 12.6929V11.6279H13.8608V12.6929C14.3528 12.8404 14.7956 13.1024 15.1588 13.4483L16.0759 12.9153L17 14.5265L16.0836 15.0591C16.1407 15.3014 16.1709 15.5541 16.1709 15.814C16.1709 16.0738 16.1407 16.3265 16.0836 16.5687L17 17.1013L16.0759 18.7126L15.1589 18.1795C14.7957 18.5255 14.3529 18.7875 13.8609 18.9349V20H12.0128V18.935C11.5208 18.7876 11.0779 18.5256 10.7147 18.1796L9.79774 18.7127L8.87359 17.1014L9.78998 16.5688ZM12.9368 17.2093C13.7022 17.2093 14.3228 16.5846 14.3228 15.814C14.3228 15.0433 13.7022 14.4186 12.9368 14.4186C12.1713 14.4186 11.5507 15.0433 11.5507 15.814C11.5507 16.5846 12.1713 17.2093 12.9368 17.2093Z"
            fill={s.cardBlinkColor}
          />
        </svg>
      ),
    },

    {
      header: t("VSProsHeader6"),
      text: (
        <>
          {t("VSProsText6_1")}
          {isXl && <br />}
          {t("VSProsText6_2")}
        </>
      ),
      pic: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M2.22222 8.9381C6.24302 8.4869 9.42989 5.61872 9.93122 2H2.22222V8.9381ZM2.22222 10.9506V18H17.7778V2H12.1673C11.6462 6.72442 7.47158 10.4816 2.22222 10.9506ZM1.11111 0H18.8889C19.5026 0 20 0.44772 20 1V19C20 19.5523 19.5026 20 18.8889 20H1.11111C0.497467 20 0 19.5523 0 19V1C0 0.44772 0.497467 0 1.11111 0ZM13.3333 14H15.5556V16H13.3333V14Z"
            fill={s.cardBlinkColor}
          />
        </svg>
      ),
    },
    {
      header: t("VSProsHeader7"),
      text: t("VSProsText7"),
      pic: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="10"
          viewBox="0 0 20 10"
          fill="none"
        >
          <path
            d="M8.52441 8.55769C7.55438 9.51923 6.37386 10 4.98287 10C3.59188 10 2.41136 9.51923 1.44133 8.55769C0.480442 7.57784 0 6.39194 0 5C0 3.5989 0.480442 2.41758 1.44133 1.45604C2.41136 0.485348 3.59188 0 4.98287 0C6.37386 0 7.55438 0.485348 8.52441 1.45604C9.49445 2.41758 9.97947 3.5989 9.97947 5C9.97947 6.4011 9.49445 7.587 8.52441 8.55769ZM2.77284 7.26648C3.35852 7.85256 4.0952 8.1456 4.98287 8.1456C5.87054 8.1456 6.60722 7.85256 7.1929 7.26648C7.78773 6.67125 8.08515 5.91575 8.08515 5C8.08515 4.08425 7.78773 3.32875 7.1929 2.73352C6.59807 2.13828 5.86139 1.84066 4.98287 1.84066C4.10435 1.84066 3.36767 2.13828 2.77284 2.73352C2.178 3.32875 1.88059 4.08425 1.88059 5C1.88059 5.91575 2.178 6.67125 2.77284 7.26648Z"
            fill={s.cardBlinkColor}
          />
          <path
            d="M15.8682 10C14.4315 10 13.2372 9.51923 12.2855 8.55769C11.3429 7.60531 10.8716 6.41941 10.8716 5C10.8716 3.57143 11.3429 2.38553 12.2855 1.44231C13.2372 0.480769 14.4315 0 15.8682 0C16.7376 0 17.5383 0.206044 18.2704 0.618132C19.0117 1.02106 19.5882 1.57051 20 2.26648L18.3665 3.21429C18.1286 2.78388 17.79 2.44963 17.3507 2.21154C16.9114 1.96429 16.4173 1.84066 15.8682 1.84066C14.9348 1.84066 14.1798 2.1337 13.6033 2.71978C13.0359 3.31502 12.7522 4.07509 12.7522 5C12.7522 5.91575 13.0359 6.67125 13.6033 7.26648C14.1798 7.85256 14.9348 8.1456 15.8682 8.1456C16.4173 8.1456 16.9114 8.02656 17.3507 7.78846C17.7991 7.54121 18.1377 7.20696 18.3665 6.78571L20 7.73352C19.5882 8.42949 19.0117 8.98352 18.2704 9.3956C17.5383 9.79853 16.7376 10 15.8682 10Z"
            fill={s.cardBlinkColor}
          />
        </svg>
      ),
    },
    {
      header: t("VSProsHeader8"),
      text: t("VSProsText8"),
      pic: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
        >
          <path
            d="M27 9.5C27.5523 9.5 28 9.92285 28 10.4444V25.5556C28 26.0772 27.5523 26.5 27 26.5H9C8.44772 26.5 8 26.0772 8 25.5556V10.4444C8 9.92285 8.44772 9.5 9 9.5H27ZM26 17.0556H10V24.6111H26V17.0556ZM26 11.3889H10V15.1667H26V11.3889ZM17 12.3333V14.2222H15V12.3333H17ZM13 12.3333V14.2222H11V12.3333H13Z"
            fill={s.cardBlinkColor}
          />
        </svg>
      ),
    },
    {
      header: t("VSProsHeader9"),
      text: t("VSProsText9"),
      pic: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
        >
          <path
            d="M24.2419 11.4413L25.8568 9.84946L27.4281 11.3984L25.8132 12.9901C27.1817 14.6765 28 16.8155 28 19.1429C28 24.5868 23.5229 29 18 29C12.4772 29 8 24.5868 8 19.1429C8 13.6989 12.4772 9.28571 18 9.28571C20.3611 9.28571 22.5311 10.0923 24.2419 11.4413ZM18 26.8095C22.2956 26.8095 25.7778 23.377 25.7778 19.1429C25.7778 14.9087 22.2956 11.4762 18 11.4762C13.7045 11.4762 10.2222 14.9087 10.2222 19.1429C10.2222 23.377 13.7045 26.8095 18 26.8095ZM16.8889 13.6667H19.1111V20.2381H16.8889V13.6667ZM13.5556 6H22.4444V8.19048H13.5556V6Z"
            fill={s.cardBlinkColor}
          />
        </svg>
      ),
    },
  ];
  return (
    <Row xs={1} lg={3} className="g-4 mt-2 mt-lg-4 align-items-stretch">
      {prosCards.map((el) => (
        <Pros2Card header={el.header} description={el.text}>
          {el.pic}
        </Pros2Card>
      ))}
    </Row>
  );
}

function MinorBanner({ isLg, isXl }) {
  const { lang, changeLang, t } = useLang();

  const { s, toggleTheme } = useTheme();
  return (
    <div className={`${styles.minorBanner} mt-5 mb-4`} style={s.DCProsCard}>
      {isXl && (
        <>
          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            width="551"
            height="174"
            viewBox="0 0 551 174"
            fill="none"
            className={styles.minorBannerLeft}
          >
            {s.DCMinorLeft}
          </svg> */}
          <svg
            width="821"
            height="220"
            viewBox="0 0 821 220"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.minorBannerLeft}
          >
            {s.VSMinorBannerLeft}
          </svg>

          <svg
            width="821"
            height="220"
            viewBox="0 0 821 220"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.minorBannerRight}
          >
            {s.VSMinorBannerRight}
          </svg>
        </>
      )}
      <h4 style={{ color: s.DCProsHeader, letterSpacing: "1.5px" }}>
        {t("DSMinorBannerHeader")}
      </h4>
      <p className="mt-4" style={{ color: s.DCProsText, margin: 0 }}>
        {t("DSMinorBannerHeaderText_1")}
        {(isLg || isXl) && <br />}
        {t("DSMinorBannerHeaderText_2")}
        {(isLg || isXl) && <br />}
        {t("DSMinorBannerHeaderText_3")}
      </p>
    </div>
  );
}
function OSBlock({ isXs, isSm, isMd, isXl }) {
  const [openedList, setOpenedList] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const { s, toggleTheme } = useTheme();
  const { lang, changeLang, t } = useLang();
  const [isTooltipVisible, setTooltipVisible] = useState(false);

  const OSItems = [
    {
      icon: (
        <svg
          width="29"
          height="28"
          viewBox="0 0 29 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28.0625 14.25C28.0625 21.6157 21.9933 27.5938 14.5 27.5938C7.00672 27.5938 0.9375 21.6157 0.9375 14.25C0.9375 6.87758 7.00672 0.90625 14.5 0.90625C21.9933 0.90625 28.0625 6.87758 28.0625 14.25Z"
            fill="#D70751"
          />
          <path
            d="M20.3829 12.8194C20.4004 13.3211 20.2512 13.5948 20.1196 14.0509C19.6807 14.1877 19.7685 14.6895 19.7246 14.8263C19.4613 14.9631 18.1885 16.3771 18.6274 15.6017C18.1885 15.921 18.2763 16.0578 17.5741 16.2858L17.5566 16.2402C15.845 17.0612 13.4312 15.4192 13.4312 13.1387C13.4136 13.2755 13.3873 13.2299 13.3434 13.2755C13.2995 10.7213 16.1522 9.26177 17.8199 10.8125C16.7227 9.48983 14.3967 9.39861 13.6067 10.995C13.1679 11.2687 13.0801 12.1809 12.9045 12.3177C12.6851 16.3315 16.1961 18.9313 19.4876 15.8753C19.8387 15.6017 20.1898 15.1456 20.3214 15.1C20.1898 15.3599 20.3478 15.1912 20.2337 15.4192C20.497 14.9631 20.2776 14.0053 20.7603 14.6803C20.7954 13.8137 21.7258 12.0349 21.2431 13.6313C21.3747 13.084 21.287 11.9893 21.5064 12.9927C21.3747 12.4454 21.6381 12.0349 21.7258 11.7156C21.4625 11.0315 20.9359 9.75437 21.5503 10.6666C20.2776 7.92994 21.5942 9.07021 22.0769 10.8946C22.033 10.4016 21.8619 9.92769 21.7258 9.48071C21.8136 9.52632 21.5503 8.47727 21.8575 9.20704C21.4625 7.70188 20.1898 6.37917 19.0048 5.64939C19.7948 6.47039 16.7227 4.96523 15.9766 4.69157C16.5033 5.01084 13.2995 5.01084 15.0769 4.72805C14.4625 4.68244 13.6726 4.9105 14.4186 4.5C13.9447 4.52737 13.3215 4.77367 13.497 4.54561C12.5754 5.04733 9.76662 7.0086 10.5566 5.95955C9.54719 6.91738 8.93277 7.60154 8.40613 8.87864C4.93905 13.9414 8.31835 21.5585 13.8042 23.7022C14.287 23.8846 15.0769 23.8846 15.7353 23.8846C14.9892 23.6566 14.8575 23.7934 14.1114 23.5197C13.5848 23.2917 13.4531 22.9724 13.0581 22.6075C13.0274 22.9724 12.0049 22.5847 12.356 22.1514C12.1365 22.1332 11.7415 21.7409 11.6099 21.5129C11.2149 21.6041 10.8638 20.8743 10.8638 20.6006C10.8199 20.7375 9.23998 19.0955 10.1616 19.5516C9.94217 19.3235 9.63496 19.2779 9.89828 19.0043C9.67885 18.3657 9.10832 18.092 9.76662 18.3201C8.80111 17.6359 8.23058 16.5413 8.66945 16.4957C8.45001 16.222 8.45001 15.9939 8.4939 15.6291C7.74782 13.9414 8.53779 11.8433 9.10832 10.4294C8.18669 10.5206 10.776 8.14887 11.4782 8.14887C11.3904 7.78398 11.961 7.32787 12.6632 7.09982C12.6193 7.05421 15.1208 5.91394 14.0675 6.73493C17.008 5.73149 20.2556 8.37692 20.4312 11.1136C20.6067 11.1592 20.4092 13.1661 20.3873 13.3029"
            fill="white"
          />
        </svg>
      ),

      os: "Debian",
      items: ["Debian 9", "Debian 10", "Debian 11", "Debian 12"],
    },
    {
      icon: (
        <svg
          width="29"
          height="28"
          viewBox="0 0 29 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.9375"
            y="0.90625"
            width="27.125"
            height="26.6875"
            rx="13.3438"
            fill="#048CFC"
          />
          <path
            d="M14.0764 7.75V13.8889H7.9375V7.75H14.0764ZM14.0764 20.75H7.9375V14.6111H14.0764V20.75ZM14.7986 7.75H20.9375V13.8889H14.7986V7.75ZM20.9375 14.6111V20.75H14.7986V14.6111H20.9375Z"
            fill="#F8F8F8"
          />
        </svg>
      ),
      os: "Windows",
      items: [
        "Windows Server 2022",
        "Windows Server 2016",
        "Windows Server 2019",
        "Windows Server 2019 RUS",
        "Windows Server 2022",
        "Windows 10",
        "Windows 11",
      ],
      info: "Тариф DE-1, FI-1, NL-1 и EE-1 не поддерживает установку операционной системы Windows",
    },
    {
      icon: (
        <svg
          width="29"
          height="28"
          viewBox="0 0 29 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28.0625 14.25C28.0625 21.6157 21.9933 27.5938 14.5 27.5938C7.00672 27.5938 0.9375 21.6157 0.9375 14.25C0.9375 6.87758 7.00672 0.90625 14.5 0.90625C21.9933 0.90625 28.0625 6.87758 28.0625 14.25Z"
            fill="#222525"
          />
          <path
            d="M22.472 15.7304C23.2835 15.665 23.9383 16.2104 23.9953 17.0323C24.0594 17.8905 23.4686 18.5888 22.6571 18.6542C21.8813 18.7197 21.1908 18.116 21.1339 17.316C21.0698 16.4577 21.6321 15.8177 22.472 15.7231V15.7304Z"
            fill="#F8F8F8"
          />
          <path
            d="M12.6348 22.5017C12.6348 21.6726 13.254 21.0398 14.0014 21.0398C14.7488 21.0398 15.4677 21.738 15.4677 22.5381C15.4677 23.3017 14.8485 23.9709 14.1295 24C13.2256 24 12.6348 23.4254 12.6348 22.5017Z"
            fill="#F8F8F8"
          />
          <path
            d="M14.8415 13.2139C14.7134 13.2794 14.6565 13.1848 14.6209 13.0903C13.4678 10.8938 13.8094 8.13 15.838 6.47899C16.3648 6.03532 17.3613 5.94077 17.7955 6.38444C17.9806 6.54445 18.0161 6.73355 18.0446 6.95902C18.1087 7.43904 18.2012 7.9118 18.5144 8.29728C18.8561 8.71185 19.2903 8.87186 19.7885 8.83549C20.2227 8.83549 20.6569 8.77003 20.9416 9.27915C21.0982 9.56281 21.0342 10.6756 20.785 10.9011C20.664 10.9956 20.5644 10.9302 20.4718 10.9011C19.7529 10.6174 19.0055 10.6174 18.2653 10.7411C18.0161 10.7702 17.8951 10.712 17.8951 10.421C17.8667 9.94101 17.7741 9.49735 17.525 9.08278C17.0552 8.22455 16.1868 8.19545 15.6245 8.98823C15.1547 9.62099 15.0337 10.3847 14.9056 11.1484C14.7846 11.8175 14.8131 12.5157 14.8415 13.2139Z"
            fill="#F8F8F8"
          />
          <path
            d="M15.6248 13.694C15.5607 13.5994 15.5963 13.5049 15.6888 13.4394C17.4612 11.7884 20.1091 11.4684 22.159 13.0903C22.6858 13.534 23.0274 14.4577 22.7498 14.9959C22.6288 15.2214 22.4722 15.3159 22.2801 15.3741C21.8459 15.5632 21.4401 15.7523 21.1625 16.1669C20.8849 16.5814 20.8209 17.0542 20.9419 17.5633C21.0344 17.9779 21.191 18.4215 20.7853 18.807C20.5646 19.0325 19.5112 19.2216 19.2264 19.0325C19.1054 18.9379 19.1339 18.8434 19.1624 18.7125C19.2549 17.9197 19.0699 17.1851 18.7923 16.4869C18.6997 16.2323 18.7282 16.1087 18.9773 16.0432C19.4115 15.9123 19.8172 15.6941 20.1304 15.3741C20.8138 14.705 20.6572 13.8467 19.7603 13.4685C19.0414 13.1485 18.294 13.214 17.5822 13.2794C16.8989 13.3085 16.244 13.5049 15.6248 13.694Z"
            fill="#F8F8F8"
          />
          <path
            d="M15.2186 14.5231C15.3111 14.4286 15.3752 14.4577 15.4677 14.5231C17.5248 15.7959 18.5783 18.3052 17.6458 20.7562C17.3967 21.389 16.5852 22.029 15.9944 21.869C15.7453 21.8036 15.6243 21.6799 15.4962 21.5199C15.2186 21.1417 14.9054 20.7853 14.4356 20.6326C13.9374 20.4726 13.5032 20.5671 13.069 20.8217C12.6988 21.0472 12.3216 21.3308 11.8518 21.0472C11.5742 20.8872 11.1044 19.9053 11.1969 19.5853C11.261 19.4616 11.382 19.4616 11.5101 19.4616C12.286 19.338 12.9124 18.9525 13.5032 18.4434C13.6882 18.2834 13.8448 18.2834 14.0014 18.5088C14.2505 18.887 14.5637 19.2071 14.9695 19.4325C15.7809 19.9126 16.5568 19.498 16.6493 18.5452C16.7418 17.7524 16.4642 17.0469 16.2151 16.3487C15.9375 15.7159 15.5958 15.105 15.2186 14.5377V14.5231Z"
            fill="#F8F8F8"
          />
          <path
            d="M14.222 14.7122C14.101 15.3449 13.8163 15.9559 13.4462 16.4941C12.3287 18.2106 10.7058 18.9088 8.71274 18.7197C7.99383 18.6542 7.40304 18.0506 7.34609 17.4469C7.31762 17.1923 7.37456 17.0032 7.53116 16.8141C7.75182 16.5305 7.93688 16.2759 8.02942 15.9268C8.21448 15.2286 7.96535 14.654 7.4671 14.1449C6.78377 13.4466 6.87631 12.8066 7.68775 12.2975C7.78029 12.232 7.90841 12.1738 8.02942 12.1084C8.21448 12.0138 8.37108 12.0138 8.43514 12.232C8.71274 12.9666 9.27506 13.5048 9.90144 13.9485C10.1221 14.1376 10.1221 14.2685 9.92991 14.4867C9.55978 14.9013 9.33912 15.4104 9.31065 15.985C9.24659 16.6832 9.65231 17.1269 10.3356 17.1269C10.7698 17.1269 11.1756 16.9669 11.5528 16.7778C12.5209 16.2686 13.2611 15.534 13.98 14.7776C14.0726 14.7485 14.101 14.6831 14.2292 14.7122H14.222Z"
            fill="#F8F8F8"
          />
          <path
            d="M9.11869 8.0354C9.18275 8.0354 9.33935 8.06449 9.48882 8.10086C10.6419 8.32633 11.3537 7.91176 11.731 6.79896C11.9801 6.06437 12.5068 5.84618 13.1973 6.22438C13.2258 6.22438 13.2258 6.25348 13.2613 6.25348C13.9803 6.66805 13.9803 6.7335 13.5389 7.36627C13.1688 7.87539 12.9766 8.44997 12.8841 9.05364C12.82 9.40275 12.699 9.46821 12.3858 9.3373C11.8876 9.14819 11.3608 9.14819 10.827 9.3373C10.2362 9.5264 9.98708 10.0719 10.1721 10.6756C10.4213 11.4683 11.1046 11.8174 11.6954 12.232C12.2862 12.6466 12.9695 12.8648 13.6244 13.1557C13.7169 13.1848 13.8735 13.1848 13.845 13.3448C13.8165 13.4394 13.6884 13.4394 13.5674 13.4394C12.1652 13.5048 10.827 13.2793 9.73795 12.3266C8.71296 11.4683 7.96558 10.421 8.08658 8.95182C8.17912 8.47179 8.52078 8.12268 9.11157 8.02813L9.11869 8.0354Z"
            fill="#F8F8F8"
          />
          <path
            d="M6.56335 16.9669C5.81597 17.0615 5.06858 16.4287 5.00452 15.6287C4.94046 14.865 5.56684 14.1013 6.27864 14.0358C7.09008 13.9413 7.83747 14.5159 7.89441 15.2795C7.92289 16.0141 7.46022 16.9015 6.55624 16.9669H6.56335Z"
            fill="#F8F8F8"
          />
          <path
            d="M19.6389 5.64985C20.4147 5.58439 21.1621 6.22443 21.2262 7.01721C21.2903 7.78089 20.6639 8.51548 19.9165 8.57366C19.105 8.63912 18.3932 8.03545 18.3292 7.2354C18.2651 6.44263 18.8274 5.70804 19.6389 5.64258V5.64985Z"
            fill="#F8F8F8"
          />
          <path
            d="M11.5104 6.2535C11.6029 7.08264 11.0406 7.78086 10.2007 7.9045C9.48177 7.99906 8.73439 7.39538 8.64185 6.69716C8.54932 5.77347 9.04758 5.10434 9.8875 5.00979C10.6634 4.91524 11.4107 5.51891 11.5033 6.2535H11.5104Z"
            fill="#F8F8F8"
          />
        </svg>
      ),
      os: "Alma Linux",
      items: ["Alma Linux 8", "Alma Linux 9"],
    },
    {
      icon: (
        <svg
          width="31"
          height="31"
          viewBox="0 0 31 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.0625 15.25C29.0625 22.6157 22.9933 28.5938 15.5 28.5938C8.00672 28.5938 1.9375 22.6157 1.9375 15.25C1.9375 7.87758 8.00672 1.90625 15.5 1.90625C22.9933 1.90625 29.0625 7.87758 29.0625 15.25Z"
            fill="#07D75E"
          />
          <path
            d="M17.943 7.92803L19.3553 9.34511L15.9453 12.7649V7.92803H17.943ZM10.6849 9.34511L14.095 12.7649V7.92803H12.0972L10.6849 9.34511ZM12.5397 7.48547H14.5374V13.203L15.0201 13.6857L15.5028 13.203V7.48547H17.5006L15.0201 5L12.5397 7.48547ZM13.7106 15L13.2279 14.5172H7.48045V12.5145L5 15L7.48045 17.4855V15.4828H13.2279L13.7106 15ZM17.2547 14.0747H22.0771V12.072L20.6648 10.6549L17.2547 14.0747ZM25 15L22.5196 12.5145V14.5172H16.8123L16.3296 15L16.8123 15.4828H22.5196V17.4855L25 15ZM7.9229 11.4461L9.37542 10.0291L13.4112 14.0747H14.095V13.3907L10.0592 9.34511L11.4715 7.92803H7.9229V11.4461ZM22.0771 7.92803H18.5687L19.981 9.34511L15.9453 13.3907V14.0747H16.6291L20.6648 10.0291L22.0771 11.4461V7.92803ZM14.095 22.072V17.2396L10.6849 20.6594L12.0972 22.0764H14.095V22.072ZM7.9229 14.0747H12.7855L9.37542 10.6549L7.9229 12.072V14.0747ZM22.0771 18.5539L20.6648 19.9709L16.6291 15.9253H15.9453V16.6093L19.981 20.6549L18.5687 22.072H22.0771V18.5539ZM22.0771 15.9253H17.2547L20.6648 19.3451L22.0771 17.928V15.9253ZM19.3553 20.6549L15.9453 17.2351V22.0675H17.943L19.3553 20.6549ZM9.37542 19.3451L12.7855 15.9253H7.9229V17.928L9.37542 19.3451ZM17.5006 22.5145H15.5028V16.797L15.0201 16.3143L14.5374 16.797V22.5145H12.5397L15.0201 25L17.5006 22.5145ZM10.0592 20.6549L14.095 16.6093V15.9253H13.4112L9.37542 19.9709L7.9229 18.5539V22.072H11.4715L10.0592 20.6549Z"
            fill="white"
          />
        </svg>
      ),
      os: "CentOS",
      items: ["CentOS 7", "CentOS 8 Stream", "CentOS 9 Stream"],
    },
    {
      icon: (
        <svg
          width="29"
          height="28"
          viewBox="0 0 29 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.9375"
            y="0.90625"
            width="27.125"
            height="26.6875"
            rx="13.3438"
            fill="#E95420"
          />
          <path
            d="M5.56149 12.4927C4.58335 12.4927 3.79688 13.284 3.79688 14.2533C3.79688 15.2227 4.58996 16.0139 5.56149 16.0139C6.53303 16.0139 7.32612 15.2227 7.32612 14.2533C7.32612 13.2773 6.53303 12.4927 5.56149 12.4927ZM18.165 20.4913C17.319 20.9793 17.0348 22.0541 17.5173 22.8981C18.0064 23.7422 19.0837 24.0323 19.9296 23.5443C20.7756 23.0564 21.0597 21.9816 20.5773 21.1375C20.0817 20.3001 19.0043 20.0099 18.165 20.4913ZM9.3948 14.2533C9.3948 12.5125 10.2606 10.976 11.5889 10.0463L10.3002 7.89003C8.75368 8.91869 7.61031 10.4947 7.12784 12.3344C7.68301 12.7894 8.03989 13.4818 8.03989 14.2533C8.03989 15.0248 7.68301 15.7171 7.12784 16.1722C7.60369 18.0119 8.75368 19.5879 10.3002 20.6166L11.5889 18.4603C10.2606 17.5306 9.3948 15.9941 9.3948 14.2533ZM14.5498 9.10989C17.2463 9.10989 19.4537 11.1673 19.6851 13.7983L22.2031 13.7588C22.0776 11.8201 21.2316 10.0792 19.923 8.80003C19.2488 9.0506 18.4756 9.01105 17.8081 8.62856C17.1339 8.23952 16.7176 7.59331 16.5986 6.88115C15.9443 6.70311 15.257 6.60419 14.5498 6.60419C13.3271 6.60419 12.1771 6.88774 11.1528 7.39548L12.382 9.58474C13.0363 9.28136 13.7766 9.10989 14.5498 9.10989ZM14.5498 19.3967C13.7766 19.3967 13.0363 19.2252 12.3754 18.9219L11.1462 21.1111C12.1706 21.6189 13.3271 21.9024 14.5432 21.9024C15.2504 21.9024 15.9377 21.8035 16.592 21.6255C16.7044 20.9199 17.1274 20.2671 17.8015 19.878C18.469 19.4889 19.2488 19.456 19.9164 19.7065C21.2184 18.4274 22.071 16.6865 22.1965 14.7478L19.6785 14.7083C19.4537 17.3327 17.2463 19.3967 14.5498 19.3967ZM18.1584 8.00873C19.0043 8.49669 20.0817 8.20655 20.5707 7.36251C21.0597 6.51848 20.769 5.44364 19.923 4.95568C19.0771 4.46772 17.9997 4.75786 17.5107 5.6019C17.0283 6.44593 17.319 7.52077 18.1584 8.00873Z"
            fill="white"
          />
        </svg>
      ),
      os: "Ubuntu",
      items: [
        "Ubuntu 16.04",
        "Ubuntu 18.04",
        "Ubuntu 20.04",
        "Ubuntu 22.04",
        "Ubuntu 24.04",
      ],
    },
  ];

  useEffect(() => {
    setSelectedItems(Array(OSItems.length).fill(0));
  }, [OSItems.length]);

  useEffect(() => {
    function handleClickOutside(event) {
      // если в данный момент какой-то список открыт
      // и при этом место клика **не** внутри любого .OSList
      if (openedList !== null && !event.target.closest(`.${styles.OSList}`)) {
        setOpenedList(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openedList]);

  return (
    <Row xs={1} lg={2} className="mt-5">
      <Col>
        <div className="d-flex text-start flex-column">
          <h3
            className={styles.OSHeader}
            style={
              isXs || isSm || isMd
                ? {
                    color: s.DCProsHeader,
                    textAlign: "center",
                    fontSize: "clamp(25px, 5vw, 32px)",
                  }
                : { color: s.DCProsHeader }
            }
          >
            {t("OSHeader1")} {isXl && <br />} {t("OSHeader2")}
          </h3>
          <p
            className={styles.OSText}
            style={
              isXs || isSm || isMd
                ? { color: s.DCProsText, textAlign: "center", fontSize: "18px" }
                : { color: s.DCProsText }
            }
            onClick={() => setOpenedList()}
          >
            {t("OSText")}
          </p>
        </div>
      </Col>
      <Col>
        <Row xs={2} sm={3} lg={3} className="g-3">
          {OSItems.map((el, index) => (
            <Col key={index}>
              <div className={styles.OSPanel} style={s.DCProsCard}>
                <div className={styles.OSHeaderWrapper}>
                  <div className="d-flex justify-content-center align-items-center">
                    {el.icon}
                    <h6 className="ms-1 m-0" style={{ color: s.DCProsHeader }}>
                      {el.os}
                    </h6>
                    {el.info && (
                      <>
                        <div style={{ position: "relative" }}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            className="ms-1"
                            style={{ marginBottom: "3px" }}
                            onMouseEnter={() => setTooltipVisible(true)}
                            onMouseLeave={() => setTooltipVisible(false)}
                          >
                            <path
                              d="M9.0013 17.3337C4.39893 17.3337 0.667969 13.6027 0.667969 9.00033C0.667969 4.39795 4.39893 0.666992 9.0013 0.666992C13.6036 0.666992 17.3346 4.39795 17.3346 9.00033C17.3346 13.6027 13.6036 17.3337 9.0013 17.3337ZM9.0013 15.667C12.6832 15.667 15.668 12.6822 15.668 9.00033C15.668 5.31843 12.6832 2.33366 9.0013 2.33366C5.3194 2.33366 2.33464 5.31843 2.33464 9.00033C2.33464 12.6822 5.3194 15.667 9.0013 15.667ZM8.16797 4.83366H9.83463V6.50033H8.16797V4.83366ZM8.16797 8.16699H9.83463V13.167H8.16797V8.16699Z"
                              fill="#A8A8A8"
                            />
                          </svg>
                          {isTooltipVisible && (
                            <div
                              style={{
                                position: "absolute",
                                top: "calc(100% + 5px)", // Позиция ниже иконки
                                left: "50%",
                                transform: "translateX(-50%)", // Центрируем по горизонтали
                                borderRadius: "4px",
                                border: "1px solid #222525",
                                padding: "0 7px",
                                background: "#FFF",
                                color: "black", // Белый текст
                                borderRadius: "4px", // Скругленные углы
                                height: "26px",
                                fontSize: "14px", // Размер текста
                                fontFamily: "Gilroy-medium", // Шрифт, как в вашем проекте
                                whiteSpace: "nowrap", // Текст в одну строку
                                zIndex: 100, // Поверх остальных элементов
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {el.info} {/* Текст tooltip из данных */}
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div
                  className={styles.OSList}
                  style={s.DCProsCard}
                  onClick={() =>
                    setOpenedList((prev) => (prev === index ? null : index))
                  }
                >
                  <h6
                    style={{
                      margin: "0",
                      color: s.DCProsHeader,
                    }}
                  >
                    {el.items[selectedItems[index]]}
                  </h6>

                  <svg
                    style={{
                      position: "absolute",
                      right: "3px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: "16px",
                      height: "16px",
                    }}
                    viewBox="0 0 40 40"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <polygon points="15,25 5,15 25,15" fill={s.DCProsHeader} />
                  </svg>
                  {openedList === index && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%", // сразу под нижней границей .OSList
                        left: 0, // прижат по левому краю
                        width: "100%", // растянуть на ширину родителя
                        background: "#fff",
                        border: "1px solid #dee4e7",
                        borderRadius: "6px",
                        zIndex: 10, // чтобы блок был поверх остальных элементов
                        maxHeight: "150px",
                        overflowY: "auto",
                        ...s.DCProsCard,
                        color: s.DCProsHeader,
                      }}
                    >
                      {el.items.map((opt, i) => (
                        <div
                          key={i}
                          className={styles.OSListItem}
                          style={s.VSSwitchBtn}
                          onClick={() => {
                            setSelectedItems((prev) => {
                              const newArr = [...prev];
                              newArr[index] = i;
                              return newArr;
                            });
                          }}
                        >
                          {opt}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
}
export default function DedicatedServersPage({ windowSize }) {
  const { lang, changeLang, t } = useLang();
  const { s, toggleTheme } = useTheme();
  const [curCountry, setCurCountry] = useState("ger");
  const countryStyle = (country) => curCountry === country && styles.selected;
  const switchBtn = windowSize.isXs
    ? { minWidth: "100%" }
    : { "--min-width": "clamp(200px, 30vw, 238px)" };

  return (
    <>
      <MainBanner isLg={windowSize.isLg} isXl={windowSize.isXl} />
      <div className="d-flex justify-content-center mt-5">
        <div
          className={styles.countrySwitch}
          style={{ ...s.VSSwitchMenu, ...switchBtn }}
        >
          <div
            className={`${styles.switchHalf} ${countryStyle("ger")}`}
            onClick={() => setCurCountry("ger")}
            style={{ ...s.VSSwitchBtn, color: s.DCProsHeader }}
          >
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_270_54982)">
                <rect width="16" height="12" fill="white" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 8H16V12H0V8Z"
                  fill="#FFD018"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 4H16V8H0V4Z"
                  fill="#E31D1C"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 0H16V4H0V0Z"
                  fill="#272727"
                />
              </g>
              <defs>
                <clipPath id="clip0_270_54982">
                  <rect width="16" height="12" fill="white" />
                </clipPath>
              </defs>
            </svg>
            {!windowSize.isXs && (
              <span className="ms-1">{t("VSSwitchBtn1")}</span>
            )}
          </div>
          <div
            className={`${styles.switchHalf} ${countryStyle("net")}`}
            onClick={() => setCurCountry("net")}
            style={{ ...s.VSSwitchBtn, color: s.DCProsHeader }}
          >
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_270_55203)">
                <rect width="16" height="12" fill="white" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 0V12H16V0H0Z"
                  fill="#F7FCFF"
                />
                <mask
                  id="mask0_270_55203"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="16"
                  height="12"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0V12H16V0H0Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0_270_55203)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0V4H16V0H0Z"
                    fill="#E31D1C"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 8V12H16V8H0Z"
                    fill="#3D58DB"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_270_55203">
                  <rect width="16" height="12" fill="white" />
                </clipPath>
              </defs>
            </svg>
            {!windowSize.isXs && (
              <span className="ms-1">{t("VSSwitchBtn3")}</span>
            )}
          </div>
          <div
            className={`${styles.switchHalf} ${countryStyle("rus")}`}
            onClick={() => setCurCountry("rus")}
            style={{ ...s.VSSwitchBtn, color: s.DCProsHeader }}
          >
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0V12H16V0H0Z"
                fill="#3D58DB"
              />
              <mask
                id="mask0_270_51699"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="16"
                height="12"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 0V12H16V0H0Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_270_51699)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 0V4H16V0H0Z"
                  fill="#F7FCFF"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 8V12H16V8H0Z"
                  fill="#C51918"
                />
              </g>
            </svg>

            {!windowSize.isXs && (
              <span className="ms-1">{t("VSSwitchBtn4")}</span>
            )}
          </div>
        </div>
      </div>

      <CountryCards curCountry={curCountry} />
      <MinorHeader
        header={t("VSMinorHeader")}
        description1={t("VSMinorHeaderText")}
        isXs={windowSize.isXs}
        isSm={windowSize.isSm}
      />
      <ProsModule2 isXl={windowSize.isXl} />
      <OSBlock {...windowSize} />

      <MinorBanner isLg={windowSize.isLg} isXl={windowSize.isXl} />
    </>
  );
}
